import React, { useEffect, useState } from 'react';
import { isEmpty, isUndefined } from 'lodash';

import AssetService from '../../../../shared/services/AssetService';
import Checkbox from '@mui/material/Checkbox';
import CheckedCircle from '../../../images/checked-circle.svg';
import CheckedSquare from '../../../images/checked-square.svg';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import LessonComponentService from '../../../services/LessonComponentService';
import { SelectionComponentProps } from '../../../models/LessonComponent';
import { SelectionOption } from '../../../models/LessonComponentContent';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import UnCheckedCircle from '../../../images/unchecked-circle.svg';
import UnCheckedSquare from '../../../images/unchecked-square.svg';
import styles from '../../../styles/SelectionCard.module.css';
import { useTheme } from '@mui/material';

export const SelectionCardView = (props: SelectionComponentProps) => {
  const muiTheme = useTheme();
  const primaryColor = muiTheme.palette.primary.main;
  const [options, setOptions] = useState<SelectionOption[]>([]);

  const isSingle = props.component.type === 'single_selection_card';

  const response = isSingle
    ? [props.response as string]
    : (props.response as string[]);
  const [selected, setSelected] = useState<string[]>(response || []);

  useEffect(() => {
    const { content, settings } = props.component;
    if (!isEmpty(options)) {
      return;
    }
    const newOptions = settings?.randomizeOptions
      ? LessonComponentService.randomizeSelectionOptions(content?.options)
      : content?.options;
    setOptions(newOptions);
  }, [props.component.content?.options]);

  useEffect(() => {
    if (!isUndefined(props.response)) {
      const _response = isSingle
        ? [props.response as string]
        : (props.response as string[]);
      setSelected(_response || []);
    }
  }, [props.response]);

  const handleClick = (selectedItem: SelectionOption) => {
    if (selectedItem) {
      if (isSingle) {
        setSelected([selectedItem.value]);
        props.onChange(selectedItem.value);
      } else {
        const currentSelected: string[] = !selected?.includes(
          selectedItem.value
        )
          ? [...selected, selectedItem.value]
          : selected?.filter((e) => e !== selectedItem.value);
        setSelected(currentSelected);
        props.onChange(currentSelected);
      }
    }
  };

  const isSelected = (item: SelectionOption) => {
    return isSingle
      ? selected[0] === item.value
      : selected?.includes(item.value);
  };

  return (
    <div className={styles.imageListContainer}>
      <ImageList
        cols={2}
        sx={{
          display: 'flex',
          overflowY: 'unset',
          flexWrap: 'wrap'
        }}
        className={styles.imageList}
      >
        {options.map((item) => (
          <ImageListItem
            key={item.value}
            sx={{
              width: '10vw',
              height: '10vw !important',
              margin: '2px',
              padding: '0px',
              minWidth: '120px',
              minHeight: '120px',
              maxWidth: '240px',
              maxHeight: '240px',
              border: '2px solid',
              borderColor: isSelected(item) ? primaryColor : 'transparent'
            }}
            className={`${styles.imageListItem} ${
              !item.image && styles.itemWithNoImage
            }`}
            onClick={() => handleClick(item)}
          >
            {item.image && (
              <img
                src={AssetService.getAssetUrl(item.image)}
                alt={item.label}
              />
            )}
            <ImageListItemBar
              position="top"
              className={styles.itemViewIcon}
              actionIcon={
                <Checkbox
                  icon={
                    isSingle ? (
                      <img src={UnCheckedCircle} />
                    ) : (
                      <img src={UnCheckedSquare} />
                    )
                  }
                  checkedIcon={
                    isSingle ? (
                      <img src={CheckedCircle} />
                    ) : (
                      <img src={CheckedSquare} />
                    )
                  }
                  className={styles.checkboxPosition}
                  checked={isSelected(item)}
                  onClick={() => handleClick(item)}
                />
              }
              actionPosition="right"
            />
            {item?.label && (
              <ImageListItemBar
                position="bottom"
                className={styles.itemViewLabel}
                title={
                  <Tooltip
                    title={LessonComponentService.stripTags(item.label)}
                    placement="bottom"
                    arrow
                  >
                    <Typography variant="caption">
                      <span
                        dangerouslySetInnerHTML={{
                          __html: LessonComponentService.getUrlWithSas(
                            item.label
                          )
                        }}
                        style={{ fontSize: '17px' }}
                      ></span>
                    </Typography>
                  </Tooltip>
                }
              />
            )}
          </ImageListItem>
        ))}
      </ImageList>
    </div>
  );
};
